import React from "react";

import { NavLink as Link } from "react-router-dom";

import { NavLink, NavItem, Nav, Navbar } from "reactstrap";

import adminRoutes from "../../../../setup/routes/admin";
import ContainerFluid from "../../../../ui/ContainerFluid";

export default function AdminNav(props) {
  const { onClickNavLink = (f) => f } = props;

  return (
    <Navbar className="navbar !min-h-[3rem]" light expand="lg">
      <ContainerFluid>
        <Nav className="mr-auto" navbar>
          <NavItem className="nav-form" />
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.homeContent.name })
              }
              to={adminRoutes.homeContent.path}
              tag={Link}
            >
              {" "}
              Contenu
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.allActualities.name })
              }
              to={adminRoutes.allActualities.path}
              tag={Link}
            >
              {" "}
              Actualités
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.teamMembers.name })
              }
              to={adminRoutes.teamMembers.path}
              tag={Link}
            >
              {" "}
              Équipe
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.faqAdmin.name })
              }
              to={adminRoutes.faqAdmin.path}
              tag={Link}
            >
              {" "}
              FAQ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.servicesAdmin.name })
              }
              to={adminRoutes.servicesAdmin.path}
              tag={Link}
            >
              {" "}
              Partenaires &amp; institutionnels
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              // onClick={() => onClickNavLink({ from: adminRoutes.programsList.name })}
              to={adminRoutes.programsList.path}
              tag={Link}
            >
              {" "}
              Programmation
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={onClickNavLink}
              to={adminRoutes.appointmentList.path}
              tag={Link}
            >
              {" "}
              Rendez-vous{" "}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={() =>
                onClickNavLink({ from: adminRoutes.userList.name })
              }
              to={adminRoutes.userList.path}
              tag={Link}
            >
              {" "}
              Utilisateurs{" "}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              onClick={onClickNavLink}
              to={adminRoutes.stats.path}
              tag={Link}
            >
              {" "}
              Chiffres{" "}
            </NavLink>
          </NavItem>
        </Nav>
      </ContainerFluid>
    </Navbar>
  );
}
